module.exports = __webpack_public_path__ + "static/media/slide01.d7dc082b.jpg";